// export const required = (field) => (value) => (value ? undefined : 'Required');
// export const maxLength = (max) => (value) =>
//   value && value.length > max ? `Must be ${max} characters or less` : undefined;
// export const maxLength15 = maxLength(15);
// export const number = (value) => value && isNaN(Number(value)) && !value.trim() ? "Must be a number" : undefined;
// const minValue = (min) => (value) =>
//   value && value < min ? `Must be at least ${min}` : undefined;
// export const onlyLetters = (value) => value && !/^[a-zA-Z]+$/.test(value) ? "Special characters not allowed." : undefined;
// export const minValue18 = minValue(18);
// export const email = (value) =>
//   value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,15}$/i.test(value) ?
//     "Invalid email address" : undefined;
// export const tooOld = (value) =>
//   value && value > 65 ? "You might be too old for this" : undefined;


// export const requiredDropdown = (field) => (value) => value != 0 ? undefined : "required";


export const required = (value) => (value ? undefined : 'Please enter field.');
// const maxLength = (max) => (value) =>
//   value && value.length > max ? `Must be ${max} characters or less` : undefined;
// const maxLength15 = maxLength(15);
// export const minLength = (min) => (value) =>
//   value && value.length < min ? `Must be ${min} characters or more` : undefined;
// export const minLength2 = minLength(2);
// const number = (value) =>
//   value && isNaN(Number(value)) ? 'Must be a number' : undefined;
// export const minValue = (min) => (value) =>
//   value && value < min ? `Must be at least ${min}` : undefined;
// const minValue18 = minValue(18);
// const email = (value) =>
//   value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,15}$/i.test(value)
//     ? 'Invalid email address'
//     : undefined;
// const tooOld = (value) =>
//   value && value > 65 ? 'You might be too old for this' : undefined;
// const aol = (value) =>
//   value && /.+@aol\.com/.test(value)
//     ? 'Really? You still use AOL for your email?'
//     : undefined;
// const alphaNumeric = (value) =>
//   value && /[^a-zA-Z0-9 ]/i.test(value)
//     ? 'Only alphanumeric characters'
//     : undefined;
export const phoneNumber = (value) =>
  value && !/^(0|[1-9][0-9]{9})$/i.test(value)
    ? 'Invalid phone number, must be 10 digits'
    : undefined;



// WEBPACK FOOTER //
// ./src/components/validations.js